import React, { Component } from 'react';

import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';

import ConfirmDeletePopup from '../Controls/ConfirmDeletePopup.js';

import './CategoryList.css';

class AssetCategoryList extends Component {

    confirmDeletePopup = React.createRef();

    constructor(props) {
        super(props);

        //state.categories holds the muster point rows (this page's legacy naming);
        //state.categoryOptions holds the real categories shown in the row dropdown;
        //state.recordingOptions maps musterPointId -> that muster point's recordings,
        //filled lazily when a row's baseline dropdown is opened
        this.state = {
            categories: [],
            categoryOptions: [],
            recordingOptions: {}
        };
    }

    componentDidMount() {
        fetch('muster_point_list', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "startIndex=0&pageSize=10"
        })
        .then(res => res.json())
        .then((data) => {
          this.setState({ categories: data });
        })
        .catch(console.log)

        fetch('category_list', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "startIndex=-1&pageCount=0" //all categories
        })
        .then(res => res.json())
        .then((data) => {
          this.setState({ categoryOptions: data });
        })
        .catch(console.log)
    }

    reloadList = (startIndex, pageSize) => {
        fetch('muster_point_list', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "startIndex=" + startIndex + "&pageSize=" + pageSize
        })
        .then(res => res.json())
        .then((data) => {
          this.setState({ categories: data });
        })
        .catch(console.log)
    }

    handleDelete = categoryId => event => {
        event.preventDefault();
        this.confirmDeletePopup.current.request(() => this.performDelete(categoryId));
    }

    performDelete = (categoryId) => {

        //const name = ReactDOM.findDOMNode(this._nameInput).value;
        //console.log(event.target.name);
        //console.log(event.target.value);
        fetch('asset_category_delete', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
            body: "musterPointId=" + encodeURIComponent(categoryId)
        })
        .then(res => res.json())
        .then(data =>
        {
            if ('true' === data[0].delete)
            {
                this.props.reloadCategories();
            }
        })
        .catch(console.log)
    }

    showUpdateCategory = (category) => {
        this.props.showUpdateCategory(category);
    }

    getCategoryName = (categoryId) => {
        for (let i = 0; i < this.state.categoryOptions.length; i++) {
            if (String(this.state.categoryOptions[i].categoryId) === String(categoryId)) {
                return this.state.categoryOptions[i].title;
            }
        }
        return '';
    }

    getCategoryColour = (categoryId) => {
        for (let i = 0; i < this.state.categoryOptions.length; i++) {
            if (String(this.state.categoryOptions[i].categoryId) === String(categoryId)) {
                return this.state.categoryOptions[i].colour;
            }
        }
        return '';
    }

    handleSetCategory = (musterPoint, categoryId) => () => {
        //muster_point_update sets title/colour/baselineRecording unconditionally, so post the
        //row's current values alongside the new categoryId (x/y/z stay untouched when omitted)
        fetch('muster_point_update', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "musterPointId=" + musterPoint.musterPointId + "&title=" + musterPoint.title + "&colour=" + musterPoint.colour + "&baselineRecording=" + (musterPoint.baselineRecording || '') + "&categoryId=" + categoryId
        })
        .then(res => res.json())
        .then(data => {
            if ('true' === data[0].update) {
                musterPoint.categoryId = categoryId;
                this.setState({ categories: this.state.categories });
            }
        })
        .catch(console.log)
    }

    //the items deliberately stay SafeAnchors (no as="button"): the row is wrapped in the
    //delete form, and a typeless <button> inside it would submit that form
    renderCategoryDropdown = (musterPoint) => {
        return (
            <Dropdown className="musterCategoryCol">
                <Dropdown.Toggle size="lg" variant="success" id="category" style={{ backgroundColor: "#" + this.getCategoryColour(musterPoint.categoryId) }}>
                    {this.getCategoryName(musterPoint.categoryId) || 'None'}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {this.state.categoryOptions.map((option) => (
                        <Dropdown.Item eventKey={[option.categoryId, musterPoint.musterPointId]} onSelect={this.handleSetCategory(musterPoint, option.categoryId)}>{option.title}</Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
        )
    }

    //the list servlet historically rendered SQL NULL as the string "null"; show blank
    //for that, real nulls and empty values alike
    baselineDisplay = (baselineRecording) => {
        return (!baselineRecording || 'null' === baselineRecording) ? '' : baselineRecording;
    }

    //baseline choices are the recordings assigned to this muster point, fetched fresh
    //each time the dropdown opens (same source as the Update popup)
    handleBaselineToggle = (musterPoint) => (isOpen) => {
        if (!isOpen) {
            return;
        }

        fetch('muster_point_recordings', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "musterPointId=" + musterPoint.musterPointId
        })
        .then(res => res.json())
        .then((data) => {
            const recordingOptions = Object.assign({}, this.state.recordingOptions);
            recordingOptions[musterPoint.musterPointId] = data;
            this.setState({ recordingOptions: recordingOptions });
        })
        .catch(console.log)
    }

    handleSetBaseline = (musterPoint, baselineRecording) => () => {
        //muster_point_update sets title/colour/baselineRecording unconditionally, so post the
        //row's current values alongside the new baseline (categoryId/x/y/z stay untouched when omitted)
        fetch('muster_point_update', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "musterPointId=" + musterPoint.musterPointId + "&title=" + musterPoint.title + "&colour=" + musterPoint.colour + "&baselineRecording=" + baselineRecording
        })
        .then(res => res.json())
        .then(data => {
            if ('true' === data[0].update) {
                musterPoint.baselineRecording = baselineRecording;
                this.setState({ categories: this.state.categories });
            }
        })
        .catch(console.log)
    }

    //same SafeAnchor caveat as the category dropdown above: the row lives inside the
    //delete form, so the items must not become typeless <button>s
    renderBaselineDropdown = (musterPoint) => {
        const options = this.state.recordingOptions[musterPoint.musterPointId] || [];

        return (
            <Dropdown className="CategoryBaseline musterBaselineLast" onToggle={this.handleBaselineToggle(musterPoint)}>
                <Dropdown.Toggle size="lg" variant="outline-secondary" id={"baseline" + musterPoint.musterPointId}>
                    {this.baselineDisplay(musterPoint.baselineRecording) || 'None'}
                </Dropdown.Toggle>
                <Dropdown.Menu className="musterBaselineMenu">
                    <Dropdown.Item onSelect={this.handleSetBaseline(musterPoint, '')}>(none)</Dropdown.Item>
                    {options.map((recording) => (
                        <Dropdown.Item onSelect={this.handleSetBaseline(musterPoint, recording.filename)}>{recording.filename}</Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
        )
    }

    //column headings, aligned with the rows below through the same width classes
    renderHeader = (showAction) => {
        return (
            <div class="card musterHeaderCard">
                <div class="CategoryBody">
                <div class="musterHeaderRow">
                <span class="CategoryMarker musterHeaderSpacer"></span>
                <span class="CategoryItem musterHeading">Title</span>
                <span class="CategoryCoordinates musterHeading">(X, Y, Z) Azimuth</span>
                <span class="musterHeading musterHeadingCategory">Category</span>
                <span class="CategoryBaseline musterHeading musterBaselineLast">Baseline Recording</span>
                {showAction && <span class="musterHeading musterHeadingAction">Action</span>}
                </div>
                </div>
            </div>
        )
    }

    render() {
        const categories = this.state.categories;
        if (1 === this.props.accessLevel)
        {
            return (
                <React.Fragment>
                {this.renderHeader(true)}
                {categories.map((category) => (
                <div class="card">
                    <div class="CategoryBody">
                    <form class="form-inline" name="frmLogout" onSubmit={this.handleDelete(category.musterPointId)}>
                    <span class="CategoryMarker" style={{'background-color' : '#' + category.colour}}></span>
                    <h2 class="CategoryItem" onClick={() => this.showUpdateCategory(category)}>{category.title}</h2>
                    <span class="CategoryCoordinates">({category.x || '0.0'}, {category.y || '0.0'}, {category.z || '0.0'}) {category.azimuth || '0'}&deg;</span>
                    { this.renderCategoryDropdown(category) }
                    { this.renderBaselineDropdown(category) }
                    <Button variant="danger" size="lg" type="submit" className="musterActionCol">Delete</Button>
                    <input type="hidden" name="categoryId" value={category.musterPointId} /></form>
                    </div>
                </div>
                ))}
                <ConfirmDeletePopup ref={this.confirmDeletePopup} />
                </React.Fragment>
            )
        }
        else
        {
            return (
                <React.Fragment>
                {this.renderHeader(false)}
                {categories.map((category) => (
                <div class="card">
                    <div class="CategoryBody">
                    <form class="form-inline" name="frmLogout"  onSubmit={this.handleDelete(category.musterPointId)}>
                    <span class="CategoryMarker" style={{'background-color' : '#' + category.colour}}></span>
                    <h2 class="CategoryItem" onClick={() => this.showUpdateCategory(category)}>{category.title}</h2>
                    <span class="CategoryCoordinates">({category.x || '0.0'}, {category.y || '0.0'}, {category.z || '0.0'}) {category.azimuth || '0'}&deg;</span>
                    { this.renderCategoryDropdown(category) }
                    { this.renderBaselineDropdown(category) }
                    </form>
                    </div>
                </div>
                ))}
                </React.Fragment>
            )
        }
    }
}

export default AssetCategoryList;
